







import React from 'react'
import aboutImg1 from '../assets/images/about-img-1.jpg';
import contactUsImg from '../assets/images/contact-us-img.svg';
import iconFinancialStrategies from '../assets/images/icon-financial-strategies.svg';
import iconPhone from '../assets/images/icon-phone.svg';
import author1 from '../assets/images/author-1.jpg';
import author2 from '../assets/images/author-2.jpg';
import author3 from '../assets/images/author-3.jpg';
import iconService1 from '../assets/images/icon-service-1.svg';
import iconService2 from '../assets/images/icon-service-2.svg';
import iconService3 from '../assets/images/icon-service-3.svg';
import iconService4 from '../assets/images/icon-service-4.svg';
import iconService5 from '../assets/images/icon-service-5.svg';
import iconService6 from '../assets/images/icon-service-6.svg';
import arrowWhite from '../assets/images/arrow-white.svg';
import whyChooseImg1 from '../assets/images/why-choose-img-1.jpg';
import whyChooseImg2 from '../assets/images/why-choose-img-2.jpg';
import iconWhyChoose1 from '../assets/images/icon-why-choose-2.svg';
import iconWhyChoose2 from '../assets/images/icon-why-choose-2.svg';
import aboutImg2 from '../assets/images/about-img-2.jpg';


import iconPricingBenefit1 from '../assets/images/icon-pricing-benefit-1.svg';
import iconPricingBenefit2 from '../assets/images/icon-pricing-benefit-2.svg';


import mission from '../assets/images/icon-our-mission.svg';
import ourvision from '../assets/images/icon-our-vision.svg';
import ourvisionnn from '../assets/images/our-vision-img.jpg';
import ourvalueimg from '../assets/images/our-value-img.jpg';
import iconourfeature1 from '../assets/images/icon-our-feature-1.svg';
import iconourfeature2 from '../assets/images/icon-our-feature-2.svg';
import iconourfeature3 from '../assets/images/icon-our-feature-3.svg';
import iconourfeature4 from '../assets/images/icon-our-feature-4.svg';
import iconourfeature5 from '../assets/images/icon-our-feature-5.svg';
import iconourfeature6 from '../assets/images/icon-our-feature-6.svg';
import ourbenefit from '../assets/images/our-benefit-img.jpg';
import ourbenefit1 from '../assets/images/icon-our-benefit-1.svg';
import ourbenefit2 from '../assets/images/icon-our-benefit-2.svg';
import ourbenefit3 from '../assets/images/icon-our-benefit-3.svg';
import ourbenefit4 from '../assets/images/icon-our-benefit-4.svg';
import ourpartner1 from '../assets/images/our-partner-1.svg';
import ourpartner2 from '../assets/images/our-partner-2.svg';
import ourpartner3 from '../assets/images/our-partner-3.svg';
import ourpartner4 from '../assets/images/our-partner-4.svg';

import imagesteam1 from '../assets/images/team-1.jpg';
import imagesteam2 from '../assets/images/team-2.jpg';
import imagesteam13 from '../assets/images/team-3.jpg';
import customerlogo from '../assets/images/customer-logo.svg';
import testimonialquotes from '../assets/images/testimonial-quotes.svg';
import icongoogle from '../assets/images/icon-google.svg';
import customerratingimg from '../assets/images/customer-rating-img.svg';
import faqsimg from '../assets/images/faqs-img.jpg';
import faqsimsatisfyclientimg1 from '../assets/images/satisfy-client-img-1.jpg';
import faqsimsatisfyclientimg2 from '../assets/images/satisfy-client-img-2.jpg';
import faqsimsatisfyclientimg3 from '../assets/images/satisfy-client-img-3.jpg';
import faqsimsatisfyclientimg4 from '../assets/images/satisfy-client-img-4.jpg';
import faqsimsatisfyclientimg5 from '../assets/images/satisfy-client-img-5.jpg';
import iconourvalue from '../assets/images/icon-our-value.svg';
import whatwedoimg1 from '../assets/images/what-we-do-img-2.jpg';
import whatwedoimg2 from '../assets/images/what-we-do-img-2.jpg';
import whatwedoimg from '../assets/images/what-we-do-img-1.jpg';
import ourmissionimg from '../assets/images/our-mission-img.jpg';
import ourbenefit01 from '../assets/images/our-benefit-img.jpg';

// import conourvalue from '../assets/images/icon-our-value.svg"';



function Payouts() {
  return (
    <>
      <div className="page-header">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-12">
              {/* Page Header Box Start */}
              <div className="page-header-box">
                <h1 className="text-anime-style-2" data-cursor="-opaque">
Make Domestic Payouts                </h1>
                <nav className="wow fadeInUp">
                  <ol className="breadcrumb">
                   
                 
                  </ol>
                </nav>
              </div>
              {/* Page Header Box End */}
            </div>
          </div>
        </div>
      </div>




      <div className="what-we-do">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              {/* What We Do Content Start */}
              <div className="what-we-do-content">
                {/* Section Title Start */}
                <div className="section-title">
                  {/* <h3 className="wow fadeInUp">what we do</h3> */}
                  <h2 className="text-anime-style-2" data-cursor="-opaque">
                    Send Payouts to Anyone, Anytime, 
 <span>Anywhere</span>
                  </h2>
                  <p className="wow fadeInUp" data-wow-delay="0.2s">
Simplify your payout processes with Click4pay Services. Our payout solutions are tailored to meet the diverse needs of businesses, enabling you to disburse funds effortlessly. Whether it’s Salary processing, vendor payments, Cashback distribution, affiliate commissions, Customer refunds, Marketplace disbursements or Freelancer payments, our platform ensures timely and secure payouts, allowing you to focus on what matters most – growing your business                  </p>
                </div>
               
                {/* What We Do Button End */}
              </div>
              {/* What We Do Content End */}
            </div>
            <div className="col-lg-6">
              {/* What We Do Images Start */}
              <div className="what-we-do-images">
                {/* What We Do Image 1 Start */}
                <div className="what-do-we-img-1">
                  <figure className="image-anime reveal">
                    <img src={whatwedoimg} alt="whatwedoimg" />
                  </figure>
                </div>
                {/* What We Do Image 1 End */}
                {/* What We Do Image 2 Start */}
                <div className="what-do-we-img-2">
                  <figure className="image-anime reveal">
                    <img src={whatwedoimg2} alt="whatwedoimg2" />
                  </figure>
                </div>
                {/* What We Do Image 2 End */}
                {/* Experience Counter Box Start */}
                <div className="experience-counter-box">
                  <div className="experience-counter-no">
                    <h2>
                      <span className="counter">5</span>+
                    </h2>
                  </div>
                  <div className="experience-counter-content">
                    <p>Years of experience in finance</p>
                  </div>
                </div>
                {/* Experience Counter Box Start End */}
              </div>
              {/* What We Do Images End */}
            </div>
          </div>
        </div>
      </div>

      <div className="our-benefit">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="our-benefit-content">
                <div className="our-benefit-img">
                  <figure className="image-anime reveal">
                    <img src={ourbenefit} alt="ourbenefit" />
                  </figure>
                </div>
              </div>

            </div>
            <div className="col-lg-6">

              <div className="what-we-do-content">
                <div className="section-title">
                  <h2 className="text-anime-style-2" data-cursor="-opaque">
                    Our one API is for all your
 <span> payout needs</span>
                  </h2>
                  <p className="wow fadeInUp" data-wow-delay="0.2s">
Our payout API enables you to automate payments to manage your finances. Experience lightning-fast transactions through our API integration.                  </p>
                </div>


              </div>



            </div>
          </div>
        </div>
      </div>

     



      
      <div className="what-we-do">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              {/* What We Do Content Start */}
              <div className="what-we-do-content">
                {/* Section Title Start */}
                <div className="section-title">
                  {/* <h3 className="wow fadeInUp">what we do</h3> */}
                  <h2 className="text-anime-style-2" data-cursor="-opaque">
                    A full feature alternative of traditional 
 <span>banking</span>
                  </h2>
                  <p className="wow fadeInUp" data-wow-delay="0.2s">
Unlike traditional banking, there is no cooling period for the newly added beneficiary in the payout. Funds can be transferred instantly by adding a beneficiary to the payout.  
            </p>
                </div>
                
                {/* What We Do List End */}
                {/* What We Do Button Start */}
                
                {/* What We Do Button End */}
              </div>
              {/* What We Do Content End */}
            </div>
            <div className="col-lg-6">
              {/* What We Do Images Start */}
              <div className="what-we-do-images">
                {/* What We Do Image 1 Start */}
                <div className="what-do-we-img-1">
                  <figure className="image-anime reveal">
                    <img src={whatwedoimg} alt="whatwedoimg" />
                  </figure>
                </div>
                {/* What We Do Image 1 End */}
                {/* What We Do Image 2 Start */}
                <div className="what-do-we-img-2">
                  <figure className="image-anime reveal">
                    <img src={whatwedoimg2} alt="whatwedoimg2" />
                  </figure>
                </div>
                {/* What We Do Image 2 End */}
                {/* Experience Counter Box Start */}
                <div className="experience-counter-box">
                  <div className="experience-counter-no">
                    <h2>
                      <span className="counter">5</span>+
                    </h2>
                  </div>
                  <div className="experience-counter-content">
                    <p>Years of experience in finance</p>
                  </div>
                </div>
                {/* Experience Counter Box Start End */}
              </div>
              {/* What We Do Images End */}
            </div>
          </div>
        </div>
      </div>
      <div className="our-benefit">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="our-benefit-content">
                <div className="our-benefit-img">
                  <figure className="image-anime reveal">
                    <img src={ourbenefit} alt="ourbenefit" />
                  </figure>
                </div>
              </div>

            </div>
            <div className="col-lg-6">

              <div className="what-we-do-content">
                <div className="section-title">
                  <h2 className="text-anime-style-2" data-cursor="-opaque">
Bulk Payments has never 
 <span> been easier</span>
                  </h2>
                  <p className="wow fadeInUp" data-wow-delay="0.2s">
Using bulk payout thousands of transactions can be done by uploading a single Excel file.
                  </p>
                </div>


              </div>



            </div>
          </div>
        </div>
      </div>

     



      
      <div className="what-we-do">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              {/* What We Do Content Start */}
              <div className="what-we-do-content">
                {/* Section Title Start */}
                <div className="section-title">
                  {/* <h3 className="wow fadeInUp">what we do</h3> */}
                  <h2 className="text-anime-style-2" data-cursor="-opaque">
Compliance and 
 <span>Security</span>
                  </h2>
                  <p className="wow fadeInUp" data-wow-delay="0.2s">
Payout solutions with the best features compliant with data privacy and security.            </p>
                </div>
                
                {/* What We Do List End */}
                {/* What We Do Button Start */}
                
                {/* What We Do Button End */}
              </div>
              {/* What We Do Content End */}
            </div>
            <div className="col-lg-6">
              {/* What We Do Images Start */}
              <div className="what-we-do-images">
                {/* What We Do Image 1 Start */}
                <div className="what-do-we-img-1">
                  <figure className="image-anime reveal">
                    <img src={whatwedoimg} alt="whatwedoimg" />
                  </figure>
                </div>
                {/* What We Do Image 1 End */}
                {/* What We Do Image 2 Start */}
                <div className="what-do-we-img-2">
                  <figure className="image-anime reveal">
                    <img src={whatwedoimg2} alt="whatwedoimg2" />
                  </figure>
                </div>
                {/* What We Do Image 2 End */}
                {/* Experience Counter Box Start */}
                <div className="experience-counter-box">
                  <div className="experience-counter-no">
                    <h2>
                      <span className="counter">5</span>+
                    </h2>
                  </div>
                  <div className="experience-counter-content">
                    <p>Years of experience in finance</p>
                  </div>
                </div>
                {/* Experience Counter Box Start End */}
              </div>
              {/* What We Do Images End */}
            </div>
          </div>
        </div>
      </div>


   <div className="our-benefit">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="our-benefit-content">
                <div className="our-benefit-img">
                  <figure className="image-anime reveal">
                    <img src={ourbenefit} alt="ourbenefit" />
                  </figure>
                </div>
              </div>

            </div>
            <div className="col-lg-6">

              <div className="what-we-do-content">
                <div className="section-title">
                  <h2 className="text-anime-style-2" data-cursor="-opaque">
Connected Banking
                  </h2>
                  <p className="wow fadeInUp" data-wow-delay="0.2s">
Connect your existing current accounts for easy cash flow control or open a new current account for your business, easily send payments and track your finances from one dashboard.                  </p>
                </div>


              </div>



            </div>
          </div>
        </div>
      </div>

    </>
  )
}

export default Payouts